import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'
import TextareaField from 'Pods/Shared/TextareaField'
import SelectField from 'Pods/Shared/SelectField'
import InputField from 'Pods/Shared/InputField'
import { required } from 'Pods/Shared/Rules/Rules'
import { RuleRunner, run } from 'Pods/Shared/RuleRunner'

const fieldValidations = [
  RuleRunner('reason', 'Reason', required),
  RuleRunner('comment', 'Comment', required),
]

class ReportModal extends React.Component {
  constructor() {
    super()

    this.state = {
      isDisabledSubmit: false,
      reason: '',
      originalContentLink: '',
      comment: '',
      showErrors: false,
    }

    this.onModalClose = this.onModalClose.bind(this)
    this.sendReport = this.sendReport.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.onReasonChange = this.onReasonChange.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
  }

  componentWillMount() {
    this.setState({ validationErrors: run(this.state, fieldValidations) })
  }

  sendReport(e) {
    e.preventDefault()

    if (this.state.reason.value === 'copyright') {
      fieldValidations.push(RuleRunner('originalContentLink', 'Original Content Link', required))
    } else {
      fieldValidations.length = 2
    }

    this.setState({ isDisabledSubmit: true, showErrors: true, validationErrors: run(this.state, fieldValidations) })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
      axios.post('/api/internal/content_reports',
        {
          report: {
            category: this.state.reason.value,
            original_content_link: this.state.originalContentLink,
            report: this.state.comment,
            content_type: 'Item',
            content_id: this.props.itemId,
          },
        }).then(response => this.onSubmitSuccess(response, e)).catch(error => this.onSubmitFailure(error))
    } else {
      this.setState({ isDisabledSubmit: false })
    }
  }

  onSubmitSuccess(response, e) {
    this.setState({
      isDisabledSubmit: false, reason: '', originalContentLink: '', comment: '',
    })
    if (response.data.success) {
      App.events.publish('app:notification:flash:success', I18n.t('model.report_form.messages.success'))
    } else {
      App.events.publish('app:notification:flash:error', response.data.message || 'Something went wrong, please try again')
    }
    this.props.closeModal(e)
  }

  onSubmitFailure(error) {
    App.events.publish('app:notification:flash:error',
      (error.response.data.errors && error.response.data.errors.join(', ')) || 'Something went wrong, please try again')

    this.setState({ isDisabledSubmit: false })
  }

  onModalClose(e) {
    this.setState({ isDisabledSubmit: false })
    this.props.closeModal(e)
  }

  handleInputChange(e) {
    const newState = this.state

    newState[e.target.name] = e.target.value
    newState.validationErrors = run(newState, fieldValidations)

    this.setState(newState)
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  onReasonChange(value) {
    const newState = this.state

    newState.reason = value
    newState.validationErrors = run(newState, fieldValidations)

    this.setState(newState)
  }


  render() {
    const options = this.props.options.map(option => { return ({ value: option[1], label: option[0] }) })

    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--product overlay-modal--jobs">
            <h2 className="heading-18">Report content</h2>
            <form onSubmit={(e) => this.sendReport(e)}>
              <div className="form-group">
                <SelectField
                  label="Reason"
                  id="reason"
                  name="reason"
                  selectedCategory={this.state.reason}
                  className="Select-outline"
                  options={options}
                  onChange={this.onReasonChange}
                  placeholder="Select"
                  errorText={this.errorFor('reason')}
                  showError={this.state.showErrors}
                />
                {this.state.reason.value === 'copyright'
                  && (
                  <InputField
                    label="Original Content Link"
                    id="originalContentLink"
                    name="originalContentLink"
                    value={this.state.originalContentLink}
                    errorText={this.errorFor('originalContentLink')}
                    showError={this.state.showErrors}
                    formClassName="form-group-grey"
                    inputClassName="form-control-grey"
                    onChange={this.handleInputChange}
                    placeholder="Insert link here..."
                  />
                  )
                }
                <TextareaField
                  id="comment"
                  name="comment"
                  label="Comment"
                  value={this.state.comment}
                  formClassName="form-group-grey"
                  inputClassName="form-control-grey"
                  onChange={this.handleInputChange}
                  placeholder="Type here..."
                  errorText={this.errorFor('comment')}
                  showError={this.state.showErrors}
                  rows={7}
                />
              </div>

              <div className="footer u-text-right u-mt10">
                <button className="btn btn-fat btn-outline-default" onClick={this.onModalClose}>Cancel</button>
                <button
                  type="submit"
                  className="btn btn-fat btn-primary u-ml10"
                  disabled={this.state.isDisabledSubmit}
                >
                  Report
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    )
  }
}

ReportModal.propTypes = {
  itemId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool,
  options: PropTypes.array.isRequired,
}

ReportModal.defaultProps = {
  modalIsOpen: false,
}

export default ReportModal
